/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Aetonix, June 19, 2014
* For information or permission request, email info@aetonixsystems.com
*/

"use strict";

var Model = require("../types/Model.js");

module.exports = Model({
	name: "sectionupdates",
	init: init,
	listeners: listeners,
	refresh: refresh
});

function init(){
	this.refresh();
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/updates/change": handle_change
	};
}

function handle_change(data) {
	var section = data.section;
	var timestamp = data.timestamp;
	var update = {};
	update[section] = timestamp;
	this.extend(update);
}

function refresh() {
	this.emit("save:trigger:start");
	return this.api.notifications.updates()
		.then(this.push.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}

function finish_save() {
	this.emit("save:trigger:finish");
}
